document.addEventListener('DOMContentLoaded', function () {
  /* Mega menu: hover remains available, chevron click pins the panel open. */
  var megaItems = Array.prototype.slice.call(document.querySelectorAll('[data-hc-mega-item]'));

  function closeMega(except) {
    megaItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-pinned');
      var toggle = item.querySelector('[data-hc-mega-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  megaItems.forEach(function (item) {
    var toggle = item.querySelector('[data-hc-mega-toggle]');
    var closeTimer;
    if (!toggle) return;

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var willOpen = !item.classList.contains('is-pinned');
      closeMega(item);
      item.classList.toggle('is-pinned', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    item.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
    });
    item.addEventListener('mouseleave', function () {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (!item.classList.contains('is-pinned')) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      }, 260);
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-hc-mega-item]')) closeMega();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMega();
      closeContact();
    }
  });

  /* Global site survey / enquiry modal. */
  var contactModal = document.querySelector('[data-hc-contact-modal]');
  var lastContactTrigger = null;

  function openContact(trigger) {
    if (!contactModal) return;
    lastContactTrigger = trigger || document.activeElement;
    closeMega();
    contactModal.classList.add('is-open');
    contactModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hc-modal-open');
    window.setTimeout(function () {
      var first = contactModal.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (first) first.focus();
    }, 40);
  }

  function closeContact() {
    if (!contactModal || !contactModal.classList.contains('is-open')) return;
    contactModal.classList.remove('is-open');
    contactModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hc-modal-open');
    if (lastContactTrigger && typeof lastContactTrigger.focus === 'function') lastContactTrigger.focus();
  }

  document.querySelectorAll('[data-hc-contact-open], a[href="#hc-contact-modal"], a[href$="/pages/contact"]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openContact(trigger);
    });
  });

  if (contactModal) {
    contactModal.querySelectorAll('[data-hc-contact-close]').forEach(function (closer) {
      closer.addEventListener('click', function (event) {
        event.preventDefault();
        closeContact();
      });
    });
  }
  if (document.querySelector('[data-hc-contact-auto-open]')) openContact();

  /* Technical-page automatic table of contents. */
  document.querySelectorAll('[data-hc-tech-page]').forEach(function (hero) {
    var section = hero.parentNode.querySelector('[data-hc-tech-article]');
    var toc = hero.parentNode.querySelector('[data-hc-tech-toc]');
    if (!section || !toc) return;

    var headings = Array.prototype.slice.call(section.querySelectorAll('h2'));
    if (!headings.length) {
      var card = toc.closest('.hc-tech-toc-card');
      if (card) card.style.display = 'none';
      return;
    }

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var slug = heading.textContent.toLowerCase().trim()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
        heading.id = slug || ('section-' + (index + 1));
      }
      var a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      toc.appendChild(a);
    });

    if ('IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(toc.querySelectorAll('a'));
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (link) { link.classList.remove('is-active'); });
            var active = toc.querySelector('a[href="#' + entry.target.id + '"]');
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
      headings.forEach(function (heading) { observer.observe(heading); });
    }
  });
});
